<template>
  <div class="locale-changer">
      <select v-model="selected" v-on:change="setLocale(selected)">
          <option v-for="(lang, key) in langs" :key="`${key}`" :value="`${key}`">{{ lang }}</option>
      </select>
    </div>
</template>
<script>
export default {
  name: 'locale-changer',
  data () {
    return { 
        selected: this.$i18n.locale,
        langs: {
            "en": "English",
            "de": "Deutsch",
            "es": "Español",
            "fr": "Français",
            "it": "Italiano",
            "nl": "Nederlands",
            "pt": "Português",
            "sv": "Svenska",
            "cn": "简体中文",
            "tw": "繁體中文",
            "ja": "日本語"
        } 
    }
  },
  methods: {
     setLocale(locale) {
      this.$i18n.locale = locale
      this.$router.push({
        params: { lang: locale },
        query: { ...this.$route.query}
      })
    } 
  }
}
</script>